module.exports = "<p>\r\n  logo works!\r\n</p>\r\n"